import { staticPageBaseURL } from "../config";

export function numberValidator(value = "", min = 1, max = Infinity) {
  let isValid = false;
  if (!String(value)) return isValid;
  if (typeof parseFloat(value) !== "number") return isValid;
  // check length
  let numString = String(value);
  if (!(numString.length >= min && numString.length <= max)) return isValid;
  return true;
}

export function lengthValidator(value = "", min = 1, max = Infinity) {
  let isValid = false;
  if (!String(value)) return isValid;
  if (!(typeof value !== "number" || typeof value !== "string")) return isValid;
  // check length
  let string = String(value);
  if (!(string.length >= min && string.length <= max)) return isValid;
  return true;
}

//static page URL
export function fullURLPath(url) {
  return `${staticPageBaseURL}${url}?header=false`;
}
